module.exports = __webpack_public_path__ + "media/pdfs/Prepworks-Academy_Curriculum-and-Package-Information_2021-c67749bef7f2b7d94fc9233a4268a561.pdf";